
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InstallPwaBanner',
  data() {
    return {
      showBanner: false,
      showInstructions: false,
      isAndroid: false,
      isIOS: false,
    };
  },
  mounted() {
    this.detectMobileOS();
    this.checkRouteAndShowBanner();
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler() {
        this.checkRouteAndShowBanner();
      },
    },
  },
  methods: {
    checkRouteAndShowBanner() {
      if (this.$route.path === '/login') {
        // Verifica se o PWA já está instalado (modo standalone)
        if (window.matchMedia('(display-mode: standalone)').matches) {
          this.showBanner = false;
          return;
        }

        setTimeout(() => {
          if (this.isAndroid || this.isIOS) {
            this.showBanner = true;
          }
        }, 2000); // Exibir após 5 segundos
      } else {
        this.showBanner = false;
      }
    },
    detectMobileOS() {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

      if (/android/i.test(userAgent)) {
        this.isAndroid = true;
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
        this.isIOS = true;
      }
    },
  },
});
